import React, { useCallback } from 'react';
import cn from 'classnames';
import { useFieldValue } from 'Shared/utils/hooks';
import identity from 'lodash/identity';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';
import { Field } from 'react-final-form';

import Input from './Input/Input';
import './CheckboxItem.scss';

type Props = {
  name: string;
  index: number;
  remove?: Function;
  placeholder?: string;
  bigSize?: boolean;
  innerRef?: {
    current: HTMLInputElement;
  };
};

function CheckboxItem({ name, placeholder, innerRef, index, remove, bigSize = false }: Props) {
  const editable = useFieldValue(`${name}.editable`);
  const freeze = useFieldValue(`${name}.freeze`);

  const handleRemoveItem = useCallback(() => remove && remove(index), [remove, index]);

  if (freeze) return null;
  return (
    <Field name={`${name}.checked`}>
      {({ input: { value, onChange } }) => (
        <div
          className={cn('onboarding-checkbox-item w-100 px-2 py-1 mb-2 cursor-pointer d-flex', {
            'onboarding-checkbox-item--checked': value,
            'onboarding-checkbox-item--big-size': bigSize,
          })}
          onClick={() => (editable ? identity : onChange(!value))}
        >
          <StyledCheckbox
            checked={value}
            labelClassName="pl-1 cursor-pointer"
            bigSize={bigSize}
            onChange={editable ? onChange : identity}
          />
          <Input
            name={`${name}.label`}
            editable={editable}
            placeholder={placeholder}
            onRemoveItem={handleRemoveItem}
            checkboxValue={value}
            onCheckboxChange={onChange}
            bigSize={bigSize}
            innerRef={innerRef}
          />
        </div>
      )}
    </Field>
  );
}

export default CheckboxItem;
